import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DesignMagazineRoomArticleDefaultEditPresenter } from "./presenter";
import { useRoomArticleQuery } from "../../model/repository/query/use-room-query";

type Props = {
	hotelID: string;
	roomID: string;
};

export const DesignMagazineRoomArticleDefaultEditContainer = memo(({ hotelID, roomID }: Props) => {
	const { data } = useRoomArticleQuery({ hotelID, roomID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <DesignMagazineRoomArticleDefaultEditPresenter hotelID={hotelID} roomID={roomID} data={data} />;
});

DesignMagazineRoomArticleDefaultEditContainer.displayName = "DesignMagazineRoomArticleDefaultEditContainer";
